// extracted by mini-css-extract-plugin
module.exports = {"content":"TextComponent-module--content--RIG1v","spacer":"TextComponent-module--spacer--2d_pa"};